// extracted by mini-css-extract-plugin
export default {"heading":"ResultList_heading__7InIi","setModeHeading":"ResultList_setModeHeading__pef+O","hint":"ResultList_hint__7B6pn"};